import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import { Meter } from "@/meters/meter";

const useMeter = (meterId: any) => {
  return useQuery({
    queryKey: [
      "meter",
      meterId,
    ],
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: !!meterId,
    queryFn: async () => {
      return await apiClient.get<Meter>(`meters/${meterId}/`);
    },
  });
}

export default useMeter;
